<template>
  <div>
    <b-card title="Patient Surgery Invoice">
      <b-card-text>
        <b-row>
          <b-col lg="4">
            <b-form-group label="General Services Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.general_services_amount"
                placeholder="General Services"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Doctor Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.surgeon_amount"
                placeholder="Doctor Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Anesthetist Services Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="anesthetistTotalPrice"
                placeholder="Anesthetist Services Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Nursing Services Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="nursingTotalPrice"
                placeholder="Nursing Services Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Admin Services Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.admin_services_amount"
                placeholder="Admin Services Amount"
              />
            </b-form-group>
          </b-col>

          <b-col lg="4">
            <b-form-group label="Mediacal Consumables Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.medical_consumables_amount"
                placeholder="Mediacal Consumables Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Mediacal Consultation Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.consultation_amount"
                placeholder="Mediacal Consultation Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Neonate Cpap Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.pre_cpap_amount"
                placeholder="Neonate Cpap Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Neonate Incubator Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.pre_incubator_amount"
                placeholder="Mediacal Consumables Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Neonate Ventameter Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.pre_ventameter_amount"
                placeholder="Neonate Ventameter Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Tissue Transplant Amount" label-for="name">
              <b-form-input
                type="number"
                id="name"
                v-model="EditForm.tissue_transplant_amount"
                placeholder="Tissue Transplant Amount"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label="Date" label-for="name">
              <datepicker
                v-model="EditForm.date"
                :calendar-button="true"
                :clear-button="true"
                format="YYYY-MM-DD HH:mm"
                :bootstrap-styling="true"
                style="height: 5rem"
                class="datebtn2"
                placeholder="YYYY-MM-DD H:i"
              ></datepicker>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
          <b-button ref="myButton" variant="primary" @click="submitItem">
            Print Invoice
          </b-button>
          <b-button
            class="hidden"
            ref="surgeryInvoiceRef"
            variant="primary"
            v-print="ServicesInvoiceBtn"
          >
            Print Servies Invoice
          </b-button>
        </div>
      </b-card-text>
    </b-card>
    <ServicesInvoice
      :patientCard="patientSurgeryData.patient_card"
      :data="this.printData"
    />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
const ServicesInvoice = () =>
  import('@/components/printables/ServicesInvoice.vue');

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
    ServicesInvoice,
  },

  props: ['doctorSurgeryId', 'patientCardData', 'patientSurgeryData'],

  data() {
    return {
      ServicesInvoiceBtn: {
        id: 'ServicesInvoice',
      },
      loading: true,
      isNotValid: false,
      surgeryId: null,
      printData: null,
      surgery: {},
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_doctor_surgery_id: '',
        general_services_amount: 0,
        nursing_amount: 0,
        anesthetist_amount: 0,
        surgeon_amount: this.patientSurgeryData.doctor_surgery.price,
        admin_services_amount: 0,
        medical_consumables_amount: 0,
        consultation_amount: 0,
        pre_cpap_amount: 0,
        pre_incubator_amount: 0,
        pre_ventameter_amount: 0,
        tissue_transplant_amount: 0,

        date: '',
      },
      createMode: false,
      errorForm: {
        patient_card_doctor_surgery_id: '',
        general_services_amount: '',
        nursing_amount: '',
        anesthetist_amount: 0,
        surgeon_amount: 0,
        admin_services_amount: '',
        medical_consumables_amount: '',
        consultation_amount: '',
        pre_cpap_amount: '',
        pre_incubator_amount: '',
        pre_ventameter_amount: '',
        tissue_transplant_amount: '',
        date: '',
      },
      params: {
        form: {},
        path: '',
      },
    };
  },

  computed: {
    nursingTotalPrice() {
      return this.patientSurgeryData.surgery_staff.reduce(
        (accumulator, currentItem) => {
          if (currentItem.anesthetist_type === 2) {
            return accumulator + currentItem.price;
          } else {
            return accumulator;
          }
        },
        0
      );
    },
    anesthetistTotalPrice() {
      return this.patientSurgeryData.surgery_staff.reduce(
        (accumulator, currentItem) => {
          if (currentItem.anesthetist_type !== 2) {
            return accumulator + currentItem.price;
          } else {
            return accumulator;
          }
        },
        0
      );
    },
  },

  methods: {
    formatDate(surgeryDate) {
      // Create a new Date object from the selected date
      const date = new Date(surgeryDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = '' + (date.getMonth() + 1); // getMonth() is zero-based
      let day = '' + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },
    submitItem() {
      this.EditForm.nursing_amount = this.nursingTotalPrice;
      this.EditForm.anesthetist_amount = this.anesthetistTotalPrice;
      this.EditForm.date = this.formatDate(this.EditForm.date);
      this.EditForm.patient_card_doctor_surgery_id = this.doctorSurgeryId;
      (this.params.form = this.EditForm),
        (this.params.path = `invoicePatientSergury`),
        this.$store
          .dispatch('create', this.params)
          .then(async (response) => {
            let url = `/invoicePatientSergury?filter[patient_card_doctor_surgery_id]=${this.doctorSurgeryId}`;

            await this.getList(url);
            this.InvoiceOtherData = this.all_data.data[0];

            this.printData = {
              ...this.InvoiceOtherData,
              ...response.data.data,
            };

            this.$refs.surgeryInvoiceRef.click();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
